module.exports = __webpack_public_path__ + "static/media/linkedin.6f684859.svg";